namespace('compass.hotel');

compass.requireLib('compass.util.format');

compass.hotel.StayVisualizationWidget = compass.defineWidget(function StayVisualizationWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _d = jQuery.dom;

	var shortDayFormat = compass.util.dateFormatter("ddd");
	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;
	var _maxRateDigits = 5;
	var _overMaxRate = false;

	var drawRate = function(rate, isLast) {
		if(rate && !isLast) {
			var formattedRate = _cf(rate);
			// regex will match all digits in the string
			var matchDigits = /[0-9]/g;
			if(!_overMaxRate && formattedRate.match(matchDigits).length > _maxRateDigits) {
				_overMaxRate = true;
			}
			return _d.div({ className : 'rate' }, formattedRate);
		} else {
			return null;
		}
	};

	/* temporary. changes data to the way it looked before standardizing data schema in our views */
	if(_settings.translate)
	{
		_settings.nights = _.map(_settings.nights, function(night,index) {
			return {
				"roomPrice" : night.availBase.roomPrice,
				"inclusiveRoomPrice" : (night.availBase.inclusiveRoomPrice || night.availBase.roomPrice),
				"date" : night.nightBase.night

			};
		});
	}

	this.render = function(widgetElem) {
		var nightBlocks = _d.div({ className : 'nightBlocks' },
			_.map(_settings.nights, function(night,index) {
				var isLast = (index === _settings.nights.length - 1);
				var date = compass.util.parse.ISODateParser(night.date);
				return _d.div({ className : 'nightBlock' },
					_d.div({ className : 'month secondaryText' }, shortDayFormat(date)),
					_d.div({ className : 'day' }, date.getDate()),
					drawRate((night.inclusiveRoomPrice || night.roomPrice), isLast),
					_d.div({ className : 'arrive' }, 'Check-in'),
					_d.div({ className : 'depart' }, 'Check-out')
				);
			})
		);
		if(_overMaxRate) {
			nightBlocks.find('.rate').addClass('largeRate');
		}
		nightBlocks.find('.nightBlock:first-child').addClass('first-child');
		nightBlocks.find('.nightBlock:last-child').addClass('last-child');

		var row = 0;
		var rowClasses = [ 'odd', 'even' ];
		var stays = _collateStays(_settings.stays, _settings.nights);
		var stayBars = _d.div({ className : 'stayBars' },
			_.map(stays, function(stay) {
				var classes = 'stayBar secondaryText offset' + stay.start + ' colspan' + stay.length;
				classes += ' ' + rowClasses[row++ % 2];
				return _d.div({ className : classes }, stay.rooms);
			})
		);

		var bedType = '';
		if (_settings.bedRequest === 2) {
			bedType = _d.div({ className : 'bedType'}, 'Bed Request: ' + _settings.bedType);
		} else {
			bedType = _d.div({ className : 'bedType'}, _settings.bedType);
		}

		widgetElem.append(
			_d.div({ className : 'roomType' }, _settings.roomType.roomTypeName,
				_settings.bedType ? bedType : ''
		),
			_d.div({ className : 'visualizationWrapper' },
				nightBlocks,
				stayBars
			)
		);
	};

	function _collateStays(stays, nights) {
		var stayMap = { };
		_.each(stays, function(s) {
			var stayKey = s.arrive + '_' + s.depart;
			if(stayMap[stayKey]) {
				stayMap[stayKey].rooms += 1;
			} else {
				stayMap[stayKey] = {
					rooms: s.rooms,
					arrive: s.arrive,
					depart: s.depart
				};
			}
		});

		var nightIndices = _.map(_.zip(nights, _.range(0, nights.length)), function(n) {
			return { date : n[0].date, index : n[1] };
		});

		var stayList = _.map(stayMap, function(stay) {
			var start = _.find(nightIndices, function(n) { return n.date == stay.arrive; });
			var end = _.find(nightIndices, function(n) { return n.date == stay.depart; });
			stay.length = end.index - start.index;
			stay.start = start.index;
			return stay;
		});

		var sorter = function(s) {
			return -(s.length * 1000 + s.rooms);
		};
		return _.sortBy(stayList, sorter);
	}

}, {
	WUID : 'defaultStayVisualizationWidgetWUID',
	widgetName : 'StayVisualizationWidget',
	meetingInfo : { },
	stays : [ ],
	nights : [ ],
	gds : false,
	translate : false
});

